<script setup lang="ts">
import { computed, toRaw, toRefs } from 'vue';

import { GrammarMenuItem } from '@nora-monorepo/grammar-ui';
import type { GeocodingFeature } from '@nora-monorepo/nora-api-client';

import {
  GeoSearchIconGenerator,
  GeoSearchNameGenerator,
} from './geo-search.utils';

interface Props {
  menuItemKey: number;
  searchResult: GeocodingFeature;
}

const props = defineProps<Props>();
const emit = defineEmits(['searchResultSelected']);
const { searchResult } = toRefs(props);

const displayName = computed(() => {
  return GeoSearchNameGenerator.generateDisplayName(searchResult.value);
});

const displayIcon = computed(() => {
  return GeoSearchIconGenerator.getIconFromFeatureProperties(searchResult.value);
});

const truncatedDisplayName = computed(() => {
  const name = displayName.value;

  if (name.length > 40) {
    // We should consider whether this is true for all resolutions (probably not).
    return `${name.substring(0, 37)}...`;
  }
  return name;
});
</script>

<template>
  <div
    class="overflow-x-scroll h-auto no-scrollbar bg-light-bg-tertiary dark:bg-dark-bg-tertiary hover:bg-light-bg-quaternary dark:hover:bg-dark-bg-quaternary"
  >
    <GrammarMenuItem
      :key="menuItemKey"
      :leading-icon-template="displayIcon"
      :label="truncatedDisplayName"
      :title="displayName"
      @select="() => emit('searchResultSelected', toRaw(searchResult))"
    />
  </div>
</template>
